import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import Layout from '../../components/layout/Layout';
import { useStore } from '../../stores/root-store-context';
import i18n from '../../i18n';
import { useTranslation } from 'react-i18next';
import ReCAPTCHA from 'react-google-recaptcha';

const ForgotPasswordForm: React.FC = () => {
    const [form] = Form.useForm();
    const { employeesStore } = useStore();
    const { t } = useTranslation();

    const onFinish = async (values: { email: string }) => {

        try {
            employeesStore.forgetPassword(values.email, i18n.language);
            message.success(t("Password recovery email sent!"));
        } catch (error) {
            message.error(t("Failed to send password recovery email!"));
        }
    };

    const handleFormChange = async () => {
        const isValid = await form.validateFields().then(
            () => true,
            () => false
        );
    };


    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={t("Forgot Password")}>
            <div style={{ marginTop: 50 }}></div>
            <Form form={form} name="forgot_password" onFinish={onFinish} layout="vertical"
                onValuesChange={handleFormChange}
                style={{ margin: 'auto', width: '500px' }}>
                <Form.Item
                    name="email"
                    label={t("Email")}
                    rules={[
                        { required: true, message: t("Enter email") },
                        { type: 'email', message: t("Invalid email format") },
                    ]}
                >
                    <Input prefix={<MailOutlined />} placeholder={t("Enter email")} styles={{ input: { padding: 16 } }} />
                </Form.Item>
                {/* <Form.Item<any>
                    name="recaptcha"
                    style={{ width: "100%" }}
                    rules={[{ required: true }]}
                >
                    <ReCAPTCHA
                        sitekey="6Lc6nZkqAAAAAOtTKcPhSoVwSod5rkHwc27x7YOK"
                        onChange={() => { }}
                    />
                </Form.Item> */}
                <Form.Item>
                    <Button type="primary" htmlType="submit"
                        className='theme-btn'
                        style={{ height: 65 }}
                        block
                    >
                        {t("Send Link")}
                    </Button>
                </Form.Item>
            </Form>
        </Layout>
    );
};

export default ForgotPasswordForm;
